export const PUBLIC_PAGE_LOCATIONS = {
  CHECKOUT_SELECT_COLLECTION: 'checkout-select-collection',
};
